const init = function () {
  // const _this = this;
  // // 建议为了方便使用，这里可以包装window.Alert
  // window.Alert = function (msg, duration = 2000) {
  //   _this.$notify({
  //     title: 'error',
  //     message: msg,
  //     type: 'error',
  //     customClass: 'el-error-msg',
  //     duration
  //   });
  // }

  // window.Tips = function (msg, duration = 2000) {
  //   _this.$notify({
  //     title: 'success',
  //     message: msg,
  //     type: 'success',
  //     duration
  //   });
  // }

  // window.Warning = function (msg, duration = 2000) {
  //   _this.$notify({
  //     title: 'warning',
  //     message: msg,
  //     type: 'warning',
  //     duration
  //   });
  // }
};

export default {
  init
}



// WEBPACK FOOTER //
// ./src/services/error.js